<template>
  <div class="companyProduct" ref="contents">
    <div class="headView">
      <p class="text">
        用户用蓝钻购买产品，购买后，可以查看购买产品的源代码。公司卖产品所获得的蓝钻将计入公司资产，由公司CEO分配。公司资产越多，公司排名越靠前。
      </p>
    </div>
    <div class="products">
      <div class="product" v-for="item in data" :key="item.pk" @click="jumpToWorkDetail(item)">
        <span v-if="company && company.is_ceo" class="takeoff" @click.stop="removeProduct(item)">下架</span>
        <div class="img" :style="{ height: `${workHeight}px`, backgroundImage:`url(${getImg(item.showwork.images)})` }">
          <!-- <img
            :src="getImg(item.showwork.images)"
            style="width:100%; height:100%;"
            alt=""
          /> -->
        </div>
        <div class="text">
          <div class="name">
            <span class="title">{{ item.showwork.name }}</span>
            <span class="sell">已售:{{item.sell_count}}</span>
          </div>
          <div class="priceView">
            <span class="price">价值: {{item.price}}蓝钻</span>
            <span class="buy" v-if="item.is_buy === false" @click.stop="buy(item)">购买</span>
            <span class="bought" v-else>已买</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "../utils";

import { types as ConfirmTypes } from "../store/modules/confirm";
import { types as CompanyTypes } from "../store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CompanyProduct",
  components: {
  },
  props: {},
  data() {
    return {
        company_id: 0,
        workHeight: 150
    };
  },
  watch: {},
  computed: {
    ...mapState({
        page: state => state.company.product.page,
        load_more: state => state.company.product.load_more,
        data: state => state.company.product.data,
        company: state => state.company.currentCompany
    })
  },
  methods: {
    ...mapMutations({
      showConfirm: ConfirmTypes.SHOW,
      hideConfirm: ConfirmTypes.HIDE,
    }),
    ...mapActions({
        fetchListProduct: CompanyTypes.FETCH_PRODUCT_LIST,
        fetchCreateProductOrder: CompanyTypes.FETCH_CREATE_PRODUCT_ORDER,
        fetchRemovePorduct: CompanyTypes.FETCH_REMOVE_PRODUCT
    }),
    ...Utils,
    // 下架产品
    removeProduct(item){
      // console.log("购买产品");
      var dic = {
          content: "是否确定下架该产品",
          submitCB: () => {
              // console.log("点了确定");
              this.fetchRemovePorduct({"pk":item.pk})
              this.hideConfirm();
          },
          cancelCB: () => {
              // console.log("点了取消");
              this.hideConfirm();
          },
          submitText: "确定",
          cancelText: "取消"
      };
      this.showConfirm(dic);
    },
    // 购买产品事件
    buy(item){
        // console.log("购买产品");
        var dic = {
            content: "是否确定购买",
            submitCB: () => {
                // console.log("点了确定");
                this.fetchCreateProductOrder({"pk":item.pk})
                this.hideConfirm();
            },
            cancelCB: () => {
                // console.log("点了取消");
                this.hideConfirm();
            },
            submitText: "确定",
            cancelText: "取消"
        };
        this.showConfirm(dic);
        
        
    },
    //作品详情页
    jumpToWorkDetail(item) {
        // console.log("进入详情页");
        let pk = item.showwork.pk;
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${pk}`,
        "_blank"
      );
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
         that.fetchListProduct({page: that.page + 1, company:that.company_id})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.workHeight = (this.$refs.contents.clientWidth - 30) / 4 - 10 - 2;
    let company_id = this.$route.params.company_id;
    this.company_id = company_id;
    this.fetchListProduct({page: 1, company:company_id})

  }
};
</script>

<style lang="less" scoped>
.companyProduct {
  background-color: #f6f6f6;
  padding: 15px;
  .headView {
    margin-bottom: 15px;
    .text {
      color: #666666;
      font-size: 12px;
    }
  }
  .products {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
  }
  .product {
    background-color: #ffffff;
    border: solid 1px #ebebeb;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% / 4 - 12px);
    position: relative;
    .takeoff{
      position: absolute;
      left: 0;
      top: 10px;
      padding: 2px 7px;
      padding-right: 10px;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      background-color: #541DFF;
      color: #ffffff;
      font-size: 11px;
      cursor: pointer;
    }
    .img {
      width: 100%;
      height: 150px;
      background-color: #e1e1e1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .text {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      .name {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .title {
          color: #2d2d2d;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          flex: 1;
          margin-right: 10px;
        }
        .sell {
          color: #666666;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
        }
      }
      .priceView {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
        margin-bottom: 10px;
        align-items: center;
        .price {
          color: #2d2d2d;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          flex: 1;
          margin-right: 10px;
        }
        .buy {
          padding: 2px 10px;
          border-radius: 15px;
          background-color: #f56501;
          color: #ffffff;
        }
        .bought{
          padding: 2px 10px;
          border-radius: 15px;
          background-color: #e1e1e1;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
